import React, { useState } from 'react';
import { Button as AdminButton } from 'react-admin';
import PublishIcon from '@mui/icons-material/Publish';
import { DropzoneDialog } from 'react-mui-dropzone';
import ResultDialog from '../../../Utilities/ResultDialog';

function UploadFileMultipleFilter() {
    const [open, setOpen] = useState(false);
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);
    const [resultDialogTitle, setResultDialogTitle] = useState('');
    const [res, setRes] = useState();

    const handleClose = () => {
        setOpen(false);
    }

    const handleResultClose = () => {
        setResultDialogOpen(false);
        setResultDialogRows([]);
        setResultDialogHeaders([]);
        setResultLoading(false);

        if(res.length > 0) {
            //fill serial_number_tim filter box with this array separated by ','
            let resString = res.join(',');
            setInputValue(document.getElementsByName("serial_number_tim")[0], resString);
        }
    }

    const setInputValue = (element, value) => {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else {
            valueSetter.call(element, value);
        }
        element.dispatchEvent(new Event('input', { bubbles: true }));
    }

    const handleSave = async (files) => {
        setOpen(false);
        setResultDialogOpen(true);
        setResultLoading(true);

        //Saving files to state for further use and closing Modal.
        var text = await (new Response(files[0])).text();
        let resultRow = [[]];
        let title = '';
        let lineBreak = text.indexOf("\r\n") > -1 ? "\r\n" : text.indexOf("\r") > -1 ? "\r" : "\n";
        let resArr = text.split(lineBreak).filter(r => r !== "" ? true : false);

        if (resArr.length > 0 && !/^[a-zA-Z0-9%\\]*$/.test(text)) {
            if(resArr.length > 100) {
                resultRow = [['Il file contiene più di 100 seriali']];
                title = 'Attenzione';
                resArr = [];
            }
            else {
                resultRow = [[text]];
                title = 'Filtrare questi apparati'
            }
        }
        else {
            resultRow = [['Il file non è nel formato previsto.']];
            title = 'Attenzione';
            resArr = [];
        }

        setResultDialogOpen(true);
        setResultDialogRows(resultRow);
        setResultDialogHeaders([]);
        setResultDialogTitle(title);
        setResultLoading(false);
        setRes(resArr);
    }

    const handleOpen = () => {
        setOpen(true);
    }

    return (
        <div>
            <AdminButton label='tim.uploadFileMultipleFilter.button_label' onClick={handleOpen.bind(this)} >
                <PublishIcon />
            </AdminButton>
            <DropzoneDialog
                open={open}
                onSave={handleSave.bind(this)}
                acceptedFiles={['application/vnd.ms-excel', 'text/csv']}
                dropzoneText={'Drag and drop a CSV file here or click'}
                filesLimit={1}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={handleClose.bind(this)}
            />
            <ResultDialog
                open={resultDialogOpen}
                rows={resultDialogRows}
                headers={resultDialogHeaders}
                loading={resultLoading}
                title={resultDialogTitle}
                onClose={handleResultClose} >
                {!resultLoading && <AdminButton label='tim.uploadFileMultipleFilter.ok' onClick={handleResultClose.bind(this)} color="primary"></AdminButton>}
            </ResultDialog>
        </div>
    );
}

export default UploadFileMultipleFilter;